import { Loader2 } from "lucide-react";
import { SectionTitle } from "./SectionTitle";
import { ReactNode } from "react";

type Props = {
  icon?: React.ReactNode;
  title: string;
  subtitle: string | ReactNode;
  alert?: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  accessory?: ReactNode;
};

export default function PaymentMethodButton({
  icon,
  title,
  subtitle,
  alert,
  onClick,
  disabled,
  loading,
  accessory,
}: Props) {
  return (
    <button
      onClick={loading ? undefined : onClick}
      className="mt-1 flex items-center justify-between bg-[--color-background-secondary] rounded-md py-2 pl-2 pr-1 w-full group disabled:cursor-not-allowed disabled:opacity-50 hover:opacity-70 transition-opacity"
      disabled={loading ? false : disabled}
    >
      <div className="flex gap-2 items-center w-full">
        {icon}
        <div className="text-start flex-1">
          <div className="flex justify-between items-center">
            <SectionTitle title={title} />
            {alert ? (
              <div className="text-[--color-alert-warning-accent] font-medium text-[10px]">
                {alert}
              </div>
            ) : null}
          </div>
          <div className="text-xs text-[--color-text-secondary]">
            {subtitle}
          </div>
        </div>
      </div>
      {loading ? (
        <div>
          <Loader2 className="h-5 w-5 animate-spin text-[--color-text-secondary]" />
        </div>
      ) : accessory ? (
        <div onClick={(e) => e.stopPropagation()}>{accessory}</div>
      ) : null}
    </button>
  );
}
